module.exports = " <button class=btn v-bind:class=\"{primary:type=='primary',secondary:type=='secondary',outline:type=='outline',warning:type=='warning',bottom:type=='bottom',disabled:disabled}\" v-bind:disabled=disabled><slot></slot></button> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/button.vue
// module id = 134
// module chunks = 1